var exports = {
  "Qs": "xa15a2ab7--32c23e--content",
  "su": "xa15a2ab7--32c23e--icon-wrapper",
  "R_": "xa15a2ab7--32c23e--heading",
  "qr": "xa15a2ab7--32c23e--footer",
};

module.exports = exports;
